<template>
<div class="app__page">
  <mobile-menu />
  <div class="page__wrapper" ref="pageWrapper">
    <div class="header">
      <i @click="toggleMenu()" class="far fa-bars" id="menu-icon"></i>
      <img class="header__logo" src="static/logo.png"/>
    </div>
    <div class="crumbs -start-page">
      <div class="crumbs__container">
        <h2>You are just 5 steps away from your dream cooker...</h2>
      </div>
    </div>
    <div class="content-area">
      <div class="cooker_img-wrapper">
        <img class="start-screen__left-cooker" src="static/start-left.png"/>
        <img class="start-screen__right-cooker" src="static/start-right.png"/>
        <img class="start-screen__center-cooker" src="static/start-centre.png"/>
      </div>
      <button class="start-screen__button" @click="startSearch">START</button>
    </div>
    <div class="footer-area">
      <p class="footer-start-message">Rangemaster Product Selector</p>
    </div>
  </div>
  <div class="privacy-popover">
    <p><a href="http://www.rangemaster.co.uk/privacy-security" target="_blank">Privacy &amp; Security</a></p>
  </div>
  </div>
</template>

<script>
import MobileMenu from '../ui/mobile-menu.vue';

export default {
  methods: {
    startSearch(){
      this.$router.push({name:'size'})
    },
    toggleMenu(){
      document.querySelector(".push__menu").classList.contains("open") ? document.querySelector(".push__menu").classList.remove("open") : document.querySelector(".push__menu").classList.add("open");
    }
  },
  components: {
      mobileMenu: MobileMenu
  },
  mounted(){
    this.$ga.screenview('start');
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/page-start.vue